import React, { useEffect } from 'react';
import connectScreen from '../../utils/connectScreen';
import saga from './saga';
import styles from './styles';
import { usersActions } from './reducer';
import UsersComponent from './components';

function Users(props) {
  const { classes, actions, objects, users: usersReducer } = props;

  useEffect(() => {
    console.log('📱 Componente Users montado, obteniendo usuarios...');
    actions.getStateFromApi();
  }, [actions]);

  return (
    <UsersComponent
      classes={classes}
      users={Object.values(objects.users || {})}
      actions={actions}
      objects={objects}
      usersState={usersReducer}
    />
  );
}

const customSelector = (state) => ({
  objects: {
    users: state.app.objects.userManagement || {},
  },
  users: state.users,
});

export default connectScreen('Users', Users, saga, usersActions, customSelector, styles);
